import * as React from "react";
import { useParams } from "react-router";
import { ErrorScreen } from "@stenajs-webui/panels";
import { useStatisticsYearSelect } from "@/features/statistics/hooks/UseStatisticsYearSelector";
import { StatisticsByCustomerDetails } from "../../components/StatisticsByCustomerDetails";

interface Props {}

interface StatisticsByCustomerDetailsScreenParams {
  customerId?: string;
  year?: string;
}

export const StatisticsByCustomerDetailsScreen: React.FC<Props> = () => {
  const { customerId } = useParams() as StatisticsByCustomerDetailsScreenParams;
  const { year } = useStatisticsYearSelect();

  if (!customerId) {
    return <ErrorScreen text={"No such customer."} />;
  }

  return <StatisticsByCustomerDetails customerId={customerId} year={year} />;
};
